import {
  FETCH_PIN_ADDRESS,
  SET_SHOW_MAP,
  ORDER_PAGE_UPDATE_BLUEPRINT_ID,
  UPDATE_FOCUSED_POINT,
  UPDATE_SELECTED_PRODUCT,
  SET_SELECTED_OTHER_PRODUCTS,
  UPDATE_MAP_POINT_ADDRESS,
  DELETE_MAP_POINT,
  FETCH_ADDRESS,
  UPDATE_ADDRESS_SEARCH_TEXT,
  SET_IS_COMPLEX,
  SET_PROPERTY_TYPE,
  SET_SELECTED_MEASUREMENT_REQUEST,
  OPEN_VALIDATION_MESSAGE_DIALOG,
  CLOSE_VALIDATION_MESSAGE_DIALOG,
  CLOSE_MAP_TOAST,
  GET_SOLAR_PRODUCTS_AVAILABILITY, LOAD_ORDER_PAGE, GET_INIT_PARAMETERS, SET_COUNTRY,
  ADD_MAP_POINT, UPDATE_MAP_POINT_LOCATION,
  CANCEL_ORDER_SELECTION,
  CHECK_IMAGE_COVERAGE,
  CHECK_IMAGE_COVERAGE_START,
  CHECK_IMAGE_COVERAGE_SUCCESS,
  CHECK_IMAGE_COVERAGE_ERROR,
  CHECK_IMAGE_COVERAGE_RESET,
  DELETE_MAP_POINT_ACTION,
  UPDATE_MAP_POINT_ADDRESS_ACTION,
  UPDATE_MAP_POINT_LOCATION_ACTION,
  VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER,
  VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_START,
  VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_SUCCESS,
  VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_ERROR,
  UPDATE_SRS_BRANCH_EMPLOYEE_INFO,
  VALIDATE_SRS_BRANCH_EMPLOYEE,
  VALIDATE_SRS_BRANCH_EMPLOYEE_START,
  VALIDATE_SRS_BRANCH_EMPLOYEE_SUCCESS,
  VALIDATE_SRS_BRANCH_EMPLOYEE_ERROR,
  VALIDATE_SRS_BRANCH_EMPLOYEE_HIDE_SUCCESS_BANNER,
  UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO,
  UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO_FOR_DISPLAY,
  UPDATE_SRS_BRANCH_EMPLOYEE_EMPTY_SUBMISSION,
  VALIDATE_SRS_BRANCH_EMPLOYEE_RESET,
  VALIDATE_SRS_BRANCH_EMPLOYEE_INFO_RESET,
  SET_PANEL_TYPE,
  PROPERTY_DATA_REQUEST,
  PROPERTY_DATA_REQUEST_SUCCESS,
  PROPERTY_DATA_REQUEST_ERROR,
  PROPERTY_DATA_RESULT,
  PROPERTY_DATA_RESULT_SUCCESS,
  PROPERTY_DATA_RESULT_ERROR,
  PROPERTY_DATA_REQUEST_LOADING,
  PROPERTY_DATA_RESULT_LOADING,
  SET_USE_EMBEDDED_EXPLORER,
  SET_SUBSCRIPTION_ESTIMATED_TOTAL,
} from 'constants/ActionTypes';

export const setShowMap = (showMap) => ({ type: SET_SHOW_MAP, showMap });

export const setCountryAndClearAddress = (country, clearAddressSearch) => ({ type: SET_COUNTRY, country, clearAddressSearch });

export const getInitParameters = () => ({ type: GET_INIT_PARAMETERS });

export const loadOrderPage = () => ({ type: LOAD_ORDER_PAGE });

export const getSolarProductsAvailability = () => ({ type: GET_SOLAR_PRODUCTS_AVAILABILITY });

export const closeMapToast = () => ({ type: CLOSE_MAP_TOAST });

export const closeValidationMessageDialog = () => ({ type: CLOSE_VALIDATION_MESSAGE_DIALOG });

export const openValidationMessageDialog = (validationMessageType) => ({ type: OPEN_VALIDATION_MESSAGE_DIALOG, validationMessageType });

export const setSelectedMeasurementRequest = (value) => ({ type: SET_SELECTED_MEASUREMENT_REQUEST, value });

export const setPropertyType = (propertyType) => ({ type: SET_PROPERTY_TYPE, propertyType });

export const setIsComplex = (isComplex, isRoofUser = false) => ({ type: SET_IS_COMPLEX, isComplex, isRoofUser });

export const updateAddressSearchText = (inputText, isOrderFlowStarted) => ({ type: UPDATE_ADDRESS_SEARCH_TEXT, inputText, isOrderFlowStarted });

export const fetchGeocodedAddress = (searchInput, country) => ({ type: FETCH_ADDRESS, searchInput, country });

export const deleteMapPoint = (deleteIndex) => ({ type: DELETE_MAP_POINT, deleteIndex });

export const deleteMapPointAction = (deleteIndex) => ({ type: DELETE_MAP_POINT_ACTION, deleteIndex });

export const updateMapPointAddress = (updateIndex, updatedAddress, building, userEditedAddress = false) => ({
  type: UPDATE_MAP_POINT_ADDRESS,
  updateIndex,
  updatedAddress,
  building,
  userEditedAddress,
});

export const updateMapPointAddressAction = (updateIndex, updatedAddress, building) => ({
  type: UPDATE_MAP_POINT_ADDRESS_ACTION,
  updateIndex,
  updatedAddress,
  building,
});

export const updateSelectedOtherProducts = (updatedSelectedOtherProducts) => ({ type: SET_SELECTED_OTHER_PRODUCTS, updatedSelectedOtherProducts });

export const updateSelectedProduct = (updatedState) => ({ type: UPDATE_SELECTED_PRODUCT, updatedState });

export const addMapPoint = (newPinLocation) => ({ type: ADD_MAP_POINT, newPinLocation });

export const updateMapPointLocation = (updateIndex, newPinLocation) => ({ type: UPDATE_MAP_POINT_LOCATION, updateIndex, newPinLocation });

export const updateMapPointLocationAction = (updateIndex, newPinLocation) => ({ type: UPDATE_MAP_POINT_LOCATION_ACTION, updateIndex, newPinLocation });

export const fetchAddressAndResetInput = (searchInput, country, resetSearchInput) => ({
  type: FETCH_ADDRESS,
  searchInput,
  country,
  resetSearchInput,
});

export const updateFocusedPointIndex = (focusedPointIndex) => ({ type: UPDATE_FOCUSED_POINT, focusedPointIndex });
export const fetchPinAddress = (pinIndex) => ({ type: FETCH_PIN_ADDRESS, pinIndex });
export const cancelOrderSelection = () => ({ type: CANCEL_ORDER_SELECTION });

export const updateBlueprintId = (bluePrintId) => ({ type: ORDER_PAGE_UPDATE_BLUEPRINT_ID, bluePrintId });

export const checkImageCoverageStart = () => ({ type: CHECK_IMAGE_COVERAGE_START });
export const checkImageCoverage = (latitude, longitude) => ({ type: CHECK_IMAGE_COVERAGE, latitude, longitude });
export const checkImageCoverageSuccess = (imageCoverageResult) => ({ type: CHECK_IMAGE_COVERAGE_SUCCESS, imageCoverageResult });
export const checkImageCoverageError = () => ({ type: CHECK_IMAGE_COVERAGE_ERROR });
export const checkImageCoverageReset = () => ({ type: CHECK_IMAGE_COVERAGE_RESET });

export const validateSRSBillingAffiliatedCustomer = () => ({ type: VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER });
export const validateSRSBillingAffiliatedCustomerStart = () => ({ type: VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_START });
export const validateSRSBillingAffiliatedCustomerSuccess = (srsValidationInfo) => ({
  type: VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_SUCCESS, srsValidationInfo,
});
export const validateSRSBillingAffiliatedCustomerError = () => ({ type: VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_ERROR });
export const updateSRSBranchEmployeeInfo = (field, value) => ({ type: UPDATE_SRS_BRANCH_EMPLOYEE_INFO, field, value });
export const validateSRSBranchEmployeeReset = () => ({ type: VALIDATE_SRS_BRANCH_EMPLOYEE_RESET });
export const updateSRSBranchEmployeeErrorInfo = (fieldId, fieldErrorValue, bannerErrorValue) => (
  {
    type: UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO, fieldId, fieldErrorValue, bannerErrorValue,
  });
export const updateSRSBranchEmployeeErrorInfoForDisplay = () => ({ type: UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO_FOR_DISPLAY });
export const validateSRSBranchEmployee = () => ({ type: VALIDATE_SRS_BRANCH_EMPLOYEE });
export const validateSRSBranchEmployeeStart = () => ({ type: VALIDATE_SRS_BRANCH_EMPLOYEE_START });
export const validateSRSBranchEmployeeSuccess = (srsValidationInfo) => ({
  type: VALIDATE_SRS_BRANCH_EMPLOYEE_SUCCESS, srsValidationInfo,
});
export const validateSRSBranchEmployeeError = (error) => ({ type: VALIDATE_SRS_BRANCH_EMPLOYEE_ERROR, error });
export const srsBranchEmployeeEmptySubmission = () => ({ type: UPDATE_SRS_BRANCH_EMPLOYEE_EMPTY_SUBMISSION });
export const srsBranchEmployeeMessageReset = () => ({ type: VALIDATE_SRS_BRANCH_EMPLOYEE_HIDE_SUCCESS_BANNER });
export const srsBranchEmployeeInfoReset = () => ({ type: VALIDATE_SRS_BRANCH_EMPLOYEE_INFO_RESET });

// Panel Management Actions
export const setPanelType = (panelType) => ({ type: SET_PANEL_TYPE, panelType });

// Property Data API Actions
export const propertyDataRequest = (completeAddress) => ({ type: PROPERTY_DATA_REQUEST, completeAddress });
export const propertyDataRequestLoading = () => ({ type: PROPERTY_DATA_REQUEST_LOADING });
export const propertyDataRequestSuccess = (requestData) => ({ type: PROPERTY_DATA_REQUEST_SUCCESS, requestData });
export const propertyDataRequestError = (error) => ({ type: PROPERTY_DATA_REQUEST_ERROR, error });

export const propertyDataResult = (requestId) => ({ type: PROPERTY_DATA_RESULT, requestId });
export const propertyDataResultLoading = () => ({ type: PROPERTY_DATA_RESULT_LOADING });
export const propertyDataResultSuccess = (resultData, evImageLatest) => ({ type: PROPERTY_DATA_RESULT_SUCCESS, resultData, evImageLatest });
export const propertyDataResultError = (error) => ({ type: PROPERTY_DATA_RESULT_ERROR, error });

// Embedded Explorer toggle
export const setUseEmbeddedExplorer = (useEmbeddedExplorer) => ({ type: SET_USE_EMBEDDED_EXPLORER, useEmbeddedExplorer });

export const setSubscriptionEstimatedTotal = (value) => ({ type: SET_SUBSCRIPTION_ESTIMATED_TOTAL, value });
